const manageInfoPopup = () => {
  let response = false;
  const expirationTime = 60 * 60 * 1000;
  const storageKey = "show_info_popup"
  // Verificar si existe la variable y si ha expirado
  const storedValue = localStorage.getItem(storageKey);
  if (storedValue) {
    const storedData = JSON.parse(storedValue);
    const currentTime = Date.now();
    if (currentTime - storedData.timestamp > expirationTime) {
      // Si ha expirado, eliminar la clave y mostrar el popup
      localStorage.removeItem(storageKey);
      response = true;
      localStorage.setItem(
        storageKey,
        JSON.stringify({ value: 1, timestamp: Date.now() })
      );
    }
  } else {
    // Si no existe, mostrar el popup y guardar la clave
    response = true;
    localStorage.setItem(
      storageKey,
      JSON.stringify({ value: 1, timestamp: Date.now() })
    );
  }

  return response;
}


export { manageInfoPopup }